import { computed, ref, watch } from '@vue/composition-api'
import { omit } from 'lodash-es'
import { PAGINATION_POSITION } from '../_data'
export const usePagination = (pagination) => {
  const pageDefault = {
    pageSizes: [10, 20, 50, 100],
    layout: 'total, sizes, prev, pager, next, jumper',
    current: 1,
    pageSize: 20,
    total: 0,
    background: false,
    position: 'right',
    pagerCount: 3
  }
  // 初始化分页
  const pageValue = ref(pagination.value)
  watch(
    () => pagination.value,
    (newVal) => {
      pageValue.value = newVal
    },
    { immediate: true, deep: true }
  )
  const localPagination = computed(() => {
    const { current, pageSize, size, page } = pageValue.value
    return {
      ...pageDefault,
      ...pageValue.value,
      current: current || page || 1,
      pageSize: pageSize || size
    }
  })

  // 设置分页
  const setPagination = (someOfPage) => {
    const newPages = {
      ...localPagination.value,
      ...someOfPage
    }
    pageValue.value = newPages
  }
  // 异步分页数据
  const asyncPage = computed(() => {
    return {
      pageSize: localPagination.value.pageSize,
      current: localPagination.value.current,
      total: localPagination.value.total
    }
  })
  // 分页数据
  const syncPage = computed(() => {
    return omit(localPagination.value, ['pageSize', 'current', 'total'])
  })
  // 分页对齐方式
  const pagePosition = computed(() => PAGINATION_POSITION[localPagination.value.position])

  return {
    asyncPage,
    syncPage,
    localPagination,
    setPagination,
    pagePosition
  }
}
